import { html, TemplateResult } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { PropertyDataUpdateLatch } from '../../../api/get-calendar-data-for-house';
import { BookingRequest, Dispatcher } from '../../../types/booking-request';
import { WPHousePosts } from '../../../types/wp-data';
import { houseListItem } from './house-list-item';

export function houseList(
	state: BookingRequest,
	dispatch: Dispatcher,
	propertyDataUpdateLatch: PropertyDataUpdateLatch,
	posts: WPHousePosts
): TemplateResult {
	return html`
		${repeat( posts, ( post ) => {
		return post.id;
	}, ( post ) => {
		return houseListItem( state, dispatch, propertyDataUpdateLatch, post );
	} )}
	`;
}
